import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import sunMoonApi from "@/api/sunmoonApi.ts";
import { homeAtom } from "./home";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistSubpageApiInfoAndHeader,
} from "./utils/weatherQueryShared";

const sunmoonAtom = atom<any>({});
const querySunmoonAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));
    const resData = await sunMoonApi.query(newParams);
    persistSubpageApiInfoAndHeader(set, resData?.data?.info);
    set(sunmoonAtom, resData.data);
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { sunmoonAtom, querySunmoonAtom };
